import React, { useEffect } from 'react';
import './StrategicTeamPage.scss'
import '../../../../../pages/styles.scss'
import tagSvg from '../../../../../../assets/images/WhoWeHelp/tag.svg'
import FooterSection from '../../../../../../components/reusable/HomePageSections/FooterSection/FooterSection.js';
import { Link } from 'react-router-dom';
import { teamMembers } from '../../../../../../components/reusable/Common/Constant.js';
import businessStrategyMainImage from '../../../../../../assets/images/Community/Business-strategy.png'

const StrategicTeamPage = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
    }, []);
    return (
        <div className='strategic-team-page-container container'>
            <div className='strategic-team-page-section section-1'>
                <div className='strategic-team-page-section-content text'>
                    <h1>Meet the Team: <span className="highlight">Business Strategy & Ops</span></h1>
                    <p>Responsible for driving the company's operational efficiency and long-term strategic growth.</p>
                    <div className='button-section'>
                        <a className='btn' href="/careers-and-culture">
                            <i className='bx bx-plus'></i>
                            Explore Career Opportunities
                        </a>
                    </div>
                </div>
                <div className='strategic-team-page-section-content image'>
                    <div className='image-container'>
                        <img src={businessStrategyMainImage} alt="" />
                    </div>
                </div>
            </div>
            <div className='strategic-team-page-section section-2'>
                <div className='strategic-team-page-section-content text'>
                    <div className='company-vision-title'>
                        <div className='tag' style={{
                            backgroundImage: `url(${tagSvg})`,
                        }}>
                            <span>Our Team</span>
                        </div>
                        <br />
                        <h1>Business Strategy & Ops</h1>
                    </div>
                    <div className='company-vision-para'>
                        <p>Jake leads the charge in steering the company’s long-term vision, growth strategies, and day-to-day operations. With a keen eye for identifying opportunities and a deep understanding of market trends, he ensures the company remains agile and competitive.</p>
                    </div>
                </div>
                <hr className="section-divider" />
                <div className='strategic-team-page-section-content text'>
                    <div className='company-vision-point bubble-point'>
                        <h2>Transparency</h2>
                    </div>
                    <div className='company-vision-point bubble-point'>
                        <h2>Feedback Driven</h2>
                    </div>
                    <div className='company-vision-point bubble-point'>
                        <h2>Professional Development Plans</h2>
                    </div>
                </div>
            </div>
            {/* <div className='strategic-team-page-section section-3'>
                <div className='strategic-team-page-section-content image'>
                    <div className='image-container'>
                        <img src={teamMembers.jake.image} alt="" />
                    </div>
                    <h1>{teamMembers.jake.name}</h1>
                    <p>{teamMembers.jake.designation}</p>
                    <div className='button-section'>
                        <Link
                            className='btn-2'
                            to="/team-member-details"
                            state={{
                                image: teamMembers.jake.image,
                                pageType: teamMembers.jake.pageType,
                                name: teamMembers.jake.name,
                                designation: teamMembers.jake.designation,
                                message: teamMembers.jake.message
                            }}
                        >
                            <i className='bx bx-right-arrow-alt' />
                            Read More
                        </Link>
                    </div>
                </div>
            </div> */}
            <div className='strategic-team-page-section section-3'>
                <div className='wrapper'>
                    <div className='strategic-team-page-section-content image'>
                        <div className='image-container image-1'>
                            <img src={teamMembers.jake.image} alt="" />
                            <h1>{teamMembers.jake.name}</h1>
                            <p>{teamMembers.jake.designation}</p>
                            <div className='button-section'>
                                <Link
                                    className='btn-2'
                                    to="/team-member-details"
                                    state={{
                                        image: teamMembers.jake.image,
                                        pageType: teamMembers.jake.pageType,
                                        name: teamMembers.jake.name,
                                        designation: teamMembers.jake.designation,
                                        message: teamMembers.jake.message
                                    }}
                                >
                                    <i className='bx bx-right-arrow-alt' />
                                    Read More
                                </Link>
                            </div>
                        </div>
                        <div className='image-container image-2'>
                            <img src={teamMembers.saba.image} alt="" />
                            <h1>{teamMembers.saba.name}</h1>
                            <p>{teamMembers.saba.designation}</p>
                            <div className='button-section'>
                                <Link
                                    className='btn-2'
                                    to="/team-member-details"
                                    state={{
                                        image: teamMembers.saba.image,
                                        pageType: teamMembers.saba.pageType,
                                        name: teamMembers.saba.name,
                                        designation: teamMembers.saba.designation,
                                        message: teamMembers.saba.message,
                                    }}
                                >
                                    <i className='bx bx-right-arrow-alt' />
                                    Read More
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <FooterSection />
        </div>
    )
}

export default StrategicTeamPage
